<div class="business-rule-form-container">
  <div nz-row class="mb-lg form-header">
    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24">
      <h4>{{currentEditIndex === -1 ? 'Add' : 'Edit'}} Business Rule</h4>
      <form [formGroup]="formService.ruleForm">

        <!-- ═══════════════════════ MAIN ROW ═══════════════════════ -->
        <div nz-row [nzGutter]="16">

          <!-- Open Parenthesis -->
          <div nz-col nzXl="2" nzLg="2" nzMd="4" nzSm="24">
            <nz-form-item>
              <nz-form-label class="custom-lable" nz-tooltip
                [nzTooltipTitle]="'Open Parenthesis'.length > 6 ? 'Open Parenthesis' : ''">
                {{ 'Open Parenthesis' | truncate:6 }}
              </nz-form-label>
              <nz-form-control>
                <nz-select formControlName="openBraces" [nzPlaceHolder]="'Select'" nzAllowClear>
                  <nz-option *ngFor="let brace of openBraces" [nzLabel]="brace.label" [nzValue]="brace.code"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Attribute Name -->
          <div nz-col nzXl="5" nzLg="5" nzMd="12" nzSm="24">
            <nz-form-item>
              <nz-form-label nzRequired>{{'ics.intelligencemgmt.attributeName' | translate}}</nz-form-label>
              <nz-form-control [nzErrorTip]="'Please select attribute'">
                <nz-select formControlName="attributeName" [nzPlaceHolder]="'Select attribute'"
                  (ngModelChange)="onAttributeChange($event)" [nzShowSearch]="true" nzAllowClear>
                  <nz-option *ngFor="let attr of businessRuleAttr"
                    [nzLabel]="formatAttributeName(attr.title)" [nzValue]="attr.val"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Operator -->
          <div nz-col nzXl="4" nzLg="4" nzMd="12" nzSm="24">
            <nz-form-item>
              <nz-form-label nzRequired>{{'intelligencemgmt.operator' | translate}}</nz-form-label>
              <nz-form-control [nzErrorTip]="'Please select operator'">
                <nz-select formControlName="operator" [nzPlaceHolder]="'Select operator'" [nzDisabled]="isLogicalOperatorDisabled()"
                  (ngModelChange)="onOperatorChange($event)" [nzShowSearch]="true" nzAllowClear>
                  <nz-option *ngFor="let op of getOperatorOptions()" [nzLabel]="op.label" [nzValue]="op.value"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!--
            MAIN Value / Field
            ══════════════════
            'triggerSelect' — attributeName === trigger (elementCode):
              nz-select from triggerValueOptions (loaded after HS code is picked)
              Disabled until pair[0] (commodityHsCode) has a value.
            All other cases — standard ngSwitch.
          -->
          <div nz-col nzXl="6" nzLg="6" nzMd="12" nzSm="24">
            <nz-form-item>
              <nz-form-label nzRequired>{{'Value/Field' | translate}}</nz-form-label>
              <nz-form-control [nzErrorTip]="valueTip">
                <ng-template #valueTip let-ctrl>
                  <ng-container *ngIf="ctrl.hasError('required')">Please enter value</ng-container>
                  <ng-container *ngIf="ctrl.hasError('pattern')">{{ getValuePatternError(formService.ruleForm.get('attributeName')?.value) }}</ng-container>
                </ng-template>
                <div class="flex-container">
                  <div class="flex-1">
                    <ng-container [ngSwitch]="getControlType()">

                      <ng-container *ngSwitchCase="'triggerSelect'">
                        <nz-spin *ngIf="triggerValueLoading" nzSimple></nz-spin>
                        <nz-select *ngIf="!triggerValueLoading"
                          formControlName="value"
                          nzPlaceHolder="Select element code"
                          [nzShowSearch]="true" nzAllowClear class="w100"
                          [nzDisabled]="!formService.ruleForm.get('pairValue_0')?.value">
                          <nz-option *ngFor="let opt of triggerValueOptions"
                            [nzLabel]="opt.code + ' - ' + opt.label" [nzValue]="opt.code"></nz-option>
                        </nz-select>
                        <small *ngIf="!triggerValueLoading && !formService.ruleForm.get('pairValue_0')?.value"
                          class="hint-text">Select a HS Code first</small>
                      </ng-container>

                      <input *ngSwitchCase="'input'" nz-input formControlName="value" placeholder="Enter value"
                        [pattern]="getValuePattern(formService.ruleForm.get('attributeName')?.value) || ''" />
                      <ng-container *ngSwitchCase="'number'">
                        <ng-container *ngIf="hasValuePattern(formService.ruleForm.get('attributeName')?.value); else plainNumberMain">
                          <input nz-input formControlName="value" placeholder="Enter value"
                            [pattern]="getValuePattern(formService.ruleForm.get('attributeName')?.value) || ''" />
                        </ng-container>
                        <ng-template #plainNumberMain>
                          <nz-input-number formControlName="value"
                            placeholder="Enter number" class="w100"></nz-input-number>
                        </ng-template>
                      </ng-container>
                      <nz-date-picker *ngSwitchCase="'date'" formControlName="value"
                        [nzFormat]="'dd-MM-yyyy'" class="w100"></nz-date-picker>
                      <nz-date-picker *ngSwitchCase="'datetime'" formControlName="value"
                        [nzFormat]="'dd-MM-yyyy HH:mm'" [nzShowTime]="true" class="w100"></nz-date-picker>

                      <ng-container *ngSwitchCase="'select'">
                        <nz-input-group nzSearch [nzSuffix]="suffixButton">
                          <input nz-input formControlName="value" placeholder="Select" readonly
                            (click)="openSelectionDialog()" class="tooltip" />
                        </nz-input-group>
                        <ng-template #suffixButton>
                          <button nz-button nzType="default" nzSize="small" (click)="openSelectionDialog()">
                            <i nz-icon nzType="search"></i>
                          </button>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'hsCode'">
                        <nz-input-group nzSearch [nzSuffix]="suffixIconButton">
                          <input nz-input formControlName="value" [disabled]="true" placeholder="HS Code" />
                        </nz-input-group>
                        <ng-template #suffixIconButton>
                          <button nzType="default" type="button" (click)="openSelectionDialog()">
                            <i nz-icon nzType="edit"></i>
                          </button>
                        </ng-template>
                      </ng-container>

                      <!-- <ng-container *ngSwitchCase="'port'">
                        <nz-input-group nzSearch [nzSuffix]="suffixPortButton">
                          <input nz-input formControlName="value" readonly placeholder="Select Port"
                            (click)="openSelectionDialog()" class="cursor-pointer" />
                        </nz-input-group>
                        <ng-template #suffixPortButton>
                          <button nz-button nzType="primary" nzSearch (click)="openSelectionDialog()">
                            <i nz-icon nzType="search"></i>
                          </button>
                        </ng-template>
                      </ng-container> -->

                    </ng-container>
                  </div>
                  <i *ngIf="shouldShowCsvUpload(formService.ruleForm.get('operator')?.value)"
                    nz-icon nzType="upload" class="upload-icon" (click)="openCsvUpload()"></i>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Close Parenthesis -->
          <div nz-col nzXl="2" nzLg="2" nzMd="4" nzSm="24">
            <nz-form-item>
              <nz-form-label class="custom-lable"
                [nzTooltipTitle]="'Close Parenthesis'.length > 6 ? 'Close Parenthesis' : undefined" nz-tooltip>
                {{ 'Close Parenthesis' | truncate:6 }}
              </nz-form-label>
              <nz-form-control>
                <nz-select formControlName="closeBraces" [nzPlaceHolder]="'Select'" nzAllowClear>
                  <nz-option *ngFor="let brace of closeBraces"
                    [nzLabel]="brace.label | truncate:15" [nzValue]="brace.code"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Logical Operator -->
          <div nz-col nzXl="5" nzLg="5" nzMd="12" nzSm="24">
            <nz-form-item>
              <nz-form-label nzRequired
                [nzTooltipTitle]="(('ics.intelligencemgmt.logicalOperator' | translate).length > 20) ? ('ics.intelligencemgmt.logicalOperator' | translate) : undefined"
                nz-tooltip>
                {{ ('ics.intelligencemgmt.logicalOperator' | translate) | truncate:20 }}
              </nz-form-label>
              <nz-form-control [nzErrorTip]="'Please select logical operator'">
                <nz-select formControlName="logicalOperator" [nzPlaceHolder]="'Select'" nzAllowClear class="min-width-100"
                  [nzDisabled]="isLogicalOperatorDisabled()">
                  <nz-option nzValue="==" [nzLabel]="'=='"></nz-option>
                  <nz-option nzValue="AND" [nzLabel]="'AND'"></nz-option>
                  <nz-option nzValue="OR" [nzLabel]="'OR'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

        </div><!-- /main row -->

        <!--
          ═══════════════════════════════════════════════════════════════════════
          PAIR ROWS  (visible when attributeName === pairConfig.trigger)

          pair[0] — commodityHsCode
            Standard hsCode dialog picker.
            On selection → getCommodityHsCodesByElementCode(hsCode)
              → stores full ElementFieldMeta in triggerFieldMetaMap
              → fills triggerValueOptions (element name dropdown above)

          pair[1] — elementValue
            DYNAMIC control type — resolved from selectedElementFieldMeta:

            inputType='T' or 'C':
              → 'input' / 'number' / 'date' / 'datetime'  (based on dataType)

            inputType='D' + masterDataLabel present:
              → 'select' → opens SelectionDialog with masterDataLabel as refTypeCode

            inputType='D' + no masterDataLabel:
              → 'apiSelect' → inline nz-select from getElementValuesByName API

            Operator options also driven by selectedElementFieldMeta.dataType.
            Disabled until main value (elementCode) is set.
          ═══════════════════════════════════════════════════════════════════════
        -->
        <ng-container *ngFor="let pairConfig of pairControls">
          <div nz-row [nzGutter]="16"
               *ngIf="formService.ruleForm.get('attributeName')?.value === pairConfig.trigger"
               class="pair-container">

            <div *ngFor="let pair of pairConfig.pairs; let i = index"
                 nz-row [nzGutter]="16" class="pair-row">

              <!-- Open Parenthesis -->
              <div nz-col nzXl="2" nzLg="2" nzMd="4" nzSm="24">
                <nz-form-item>
                  <nz-form-label>{{ 'Open Parenthesis' | truncate:6 }}</nz-form-label>
                  <nz-form-control>
                    <nz-select [formControlName]="'pairOpenBraces_' + i" [nzPlaceHolder]="'Select'" nzAllowClear>
                      <nz-option *ngFor="let brace of openBraces" [nzLabel]="brace.label" [nzValue]="brace.code"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Attribute Name (readonly) -->
              <div nz-col nzXl="5" nzLg="5" nzMd="12" nzSm="24">
                <nz-form-item>
                  <nz-form-label nzRequired>{{ formatAttributeName(pair.attributeName) }}</nz-form-label>
                  <nz-form-control>
                    <input nz-input [value]="formatAttributeName(pair.attributeName)" readonly class="readonly-bg" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!--
                Operator — pair[1] uses dynamic operator options based on dataType.
                pair[0] uses standard attribute-based operator options.
              -->
              <div nz-col nzXl="4" nzLg="4" nzMd="12" nzSm="24">
                <nz-form-item>
                  <nz-form-label nzRequired>{{'intelligencemgmt.operator' | translate}}</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Please select operator'">
                    <nz-select [formControlName]="'pairOperator_' + i"
                      [nzPlaceHolder]="'Select operator'" [nzShowSearch]="true" nzAllowClear>
                      <!--
                        pair[1] (apiTriggerAttribute set): use getElementValueOperatorOptions()
                        pair[0]: use getPairOperatorOptions() based on businessRuleAttr
                      -->
                      <ng-container *ngIf="pair.apiTriggerAttribute; else standardPairOperatorOpts">
                        <nz-option *ngFor="let op of getElementValueOperatorOptions()"
                          [nzLabel]="op.label" [nzValue]="op.value"></nz-option>
                      </ng-container>
                      <ng-template #standardPairOperatorOpts>
                        <nz-option *ngFor="let op of getPairOperatorOptions(pair.attributeName)"
                          [nzLabel]="op.label" [nzValue]="op.value"></nz-option>
                      </ng-template>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!--
                Value / Field — PAIR ROW
                ════════════════════════════════════════════════════

                pair[0] (commodityHsCode, no apiTriggerAttribute):
                  → standard hsCode dialog picker

                pair[1] (elementValue, apiTriggerAttribute set):
                  Resolved dynamically from selectedElementFieldMeta:

                  getElementValueControlType() returns:
                    'input'     → plain text input
                    'number'    → nz-input-number
                    'date'      → nz-date-picker (dd-MM-yyyy)
                    'datetime'  → nz-date-picker with time
                    'select'    → readonly input + search btn → SelectionDialog
                                  (refTypeCode = masterDataLabel)
                    'apiSelect' → inline nz-select from getElementValuesByName API
                                  (spinner while loading, input fallback if empty)

                  All controls disabled until isPairEnabled (elementCode selected).
              -->
              <div nz-col nzXl="6" nzLg="6" nzMd="12" nzSm="24">
                <nz-form-item>
                  <nz-form-label nzRequired>Value</nz-form-label>
                  <nz-form-control
                    [nzErrorTip]="pairValueTip">
                    <ng-template #pairValueTip let-ctrl>
                      <ng-container *ngIf="ctrl.hasError('required')">Please enter {{ formatAttributeName(pair.attributeName) }} value</ng-container>
                      <ng-container *ngIf="ctrl.hasError('pattern')">{{ getValuePatternError(pair.attributeName) }}</ng-container>
                    </ng-template>
                    <div class="flex-container">
                      <div class="flex-1">

                        <!-- ─── pair[1]: API-triggered, dynamic control ─────────── -->
                        <ng-container *ngIf="pair.apiTriggerAttribute; else standardPairControl">

                          <!-- Spinner while loading -->
                          <nz-spin *ngIf="isPairLoading(i)" nzSimple></nz-spin>

                          <ng-container *ngIf="!isPairLoading(i)">
                            <ng-container [ngSwitch]="getElementValueControlType()">

                              <!-- input (dataType S, B or inputType T) -->
                              <input *ngSwitchCase="'input'" nz-input
                                [formControlName]="'pairValue_' + i"
                                placeholder="Enter value"
                                [disabled]="!isPairEnabled(pairConfig, i)"
                                [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                  (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />

                              <!-- number (dataType N or DEC) -->
                              <nz-input-number *ngSwitchCase="'number'"
                                [formControlName]="'pairValue_' + i"
                                placeholder="Enter number" class="w100"
                                [nzDisabled]="!isPairEnabled(pairConfig, i)"
                                [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                  (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                              </nz-input-number>

                              <!-- date (dataType D, inputType C) -->
                              <nz-date-picker *ngSwitchCase="'date'"
                                [formControlName]="'pairValue_' + i"
                                [nzFormat]="'dd-MM-yyyy'" class="w100"
                                [nzDisabled]="!isPairEnabled(pairConfig, i)"
                                [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                  (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                              </nz-date-picker>

                              <!-- datetime (dataType DT, inputType C) -->
                              <nz-date-picker *ngSwitchCase="'datetime'"
                                [formControlName]="'pairValue_' + i"
                                [nzFormat]="'dd-MM-yyyy HH:mm'" [nzShowTime]="true" class="w100"
                                [nzDisabled]="!isPairEnabled(pairConfig, i)"
                                [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                  (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                              </nz-date-picker>

                              <!--
                                select (inputType D + masterDataLabel present)
                                → opens SelectionDialog with masterDataLabel as refTypeCode
                              -->
                              <ng-container *ngSwitchCase="'select'">
                                <nz-input-group nzSearch [nzSuffix]="elemValSelSuffix">
                                  <input nz-input [formControlName]="'pairValue_' + i"
                                    placeholder="Select value" readonly
                                    [disabled]="!isPairEnabled(pairConfig, i)"
                                    (click)="isPairEnabled(pairConfig, i) && openElementValueSelectionDialog(i)"
                                    class="tooltip"
                                    [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                      (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />
                                </nz-input-group>
                                <ng-template #elemValSelSuffix>
                                  <button nz-button nzType="default" nzSize="small"
                                    [disabled]="!isPairEnabled(pairConfig, i)"
                                    (click)="openElementValueSelectionDialog(i)">
                                    <i nz-icon nzType="search"></i>
                                  </button>
                                </ng-template>
                              </ng-container>

                              <!--
                                apiSelect (inputType D + no masterDataLabel)
                                → inline nz-select populated from getElementValuesByName API
                              -->
                              <ng-container *ngSwitchCase="'apiSelect'">
                                <nz-select *ngIf="hasPairOptions(i)"
                                  [formControlName]="'pairValue_' + i"
                                  nzPlaceHolder="Select value" [nzShowSearch]="true" nzAllowClear
                                  [nzDisabled]="!isPairEnabled(pairConfig, i)"
                                  class="w100"
                                  [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                    (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                                  <nz-option *ngFor="let opt of getPairOptionsList(i)"
                                    [nzLabel]="opt.label" [nzValue]="opt.code"></nz-option>
                                </nz-select>
                                <!-- Fallback if API returned no options -->
                                <input nz-input *ngIf="!hasPairOptions(i)"
                                  [formControlName]="'pairValue_' + i"
                                  placeholder="Enter value"
                                  [disabled]="!isPairEnabled(pairConfig, i)"
                                  [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                    (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />
                              </ng-container>

                              <!-- Default fallback -->
                              <input *ngSwitchDefault nz-input
                                [formControlName]="'pairValue_' + i"
                                placeholder="Enter value"
                                [disabled]="!isPairEnabled(pairConfig, i)"
                                [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                  (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />

                            </ng-container>

                            <!-- Hint when element name not yet selected -->
                            <small *ngIf="!isPairEnabled(pairConfig, i)" class="hint-text">
                              Select an element code first
                            </small>
                          </ng-container>

                        </ng-container>
                        <!-- /pair[1] -->

                        <!-- ─── pair[0]: standard control (no apiTriggerAttribute) ─── -->
                        <ng-template #standardPairControl>
                          <ng-container [ngSwitch]="getPairControlType(pair.attributeName)">

                            <input *ngSwitchCase="'input'" nz-input [formControlName]="'pairValue_' + i"
                              [pattern]="getValuePattern(pair.attributeName) || ''"
                              [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />

                            <ng-container *ngSwitchCase="'number'">
                              <ng-container *ngIf="hasValuePattern(pair.attributeName); else plainNumberPair">
                                <input nz-input [formControlName]="'pairValue_' + i"
                                  [pattern]="getValuePattern(pair.attributeName) || ''"
                                  [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                    (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />
                              </ng-container>
                              <ng-template #plainNumberPair>
                                <nz-input-number [formControlName]="'pairValue_' + i"
                                  class="w100"
                                  [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                    (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                                </nz-input-number>
                              </ng-template>
                            </ng-container>

                            <nz-date-picker *ngSwitchCase="'date'" [formControlName]="'pairValue_' + i"
                              [nzFormat]="'dd-MM-yyyy'" class="w100"
                              [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                            </nz-date-picker>

                            <nz-date-picker *ngSwitchCase="'datetime'" [formControlName]="'pairValue_' + i"
                              [nzFormat]="'dd-MM-yyyy HH:mm'" [nzShowTime]="true" class="w100"
                              [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)">
                            </nz-date-picker>

                            <!-- hsCode dialog picker -->
                            <ng-container *ngSwitchCase="'hsCode'">
                              <nz-input-group nzSearch [nzSuffix]="pairHsSuffix">
                                <input nz-input [formControlName]="'pairValue_' + i"
                                  [disabled]="true" placeholder="HS Code"
                                  [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                    (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />
                              </nz-input-group>
                              <ng-template #pairHsSuffix>
                                <button nzType="default" type="button"
                                  (click)="openPairHscodeDialog(pair.attributeName, i, true)">
                                  <i nz-icon nzType="edit"></i>
                                </button>
                              </ng-template>
                            </ng-container>

                            <ng-container *ngSwitchCase="'select'">
                              <nz-input-group nzSearch [nzSuffix]="pairSelSuffix">
                                <input nz-input [formControlName]="'pairValue_' + i"
                                  placeholder="Select" readonly
                                  (click)="openPairSelectionDialog(pair.attributeName, i)"
                                  class="tooltip"
                                  [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                    (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />
                              </nz-input-group>
                              <ng-template #pairSelSuffix>
                                <button nz-button nzType="default" nzSize="small"
                                  (click)="openPairSelectionDialog(pair.attributeName, i)">
                                  <i nz-icon nzType="search"></i>
                                </button>
                              </ng-template>
                            </ng-container>

                            <input *ngSwitchDefault nz-input [formControlName]="'pairValue_' + i"
                              [class.ng-invalid]="formService.ruleForm.get('pairValue_' + i)?.invalid &&
                                (formService.ruleForm.get('pairValue_' + i)?.dirty || formService.ruleForm.get('pairValue_' + i)?.touched)" />

                          </ng-container>
                        </ng-template>

                      </div>
                      <i *ngIf="shouldShowCsvUpload(formService.ruleForm.get('pairOperator_' + i)?.value)"
                        nz-icon nzType="upload" class="upload-icon" (click)="openCsvUpload()"></i>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Close Parenthesis -->
              <div nz-col nzXl="2" nzLg="2" nzMd="4" nzSm="24">
                <nz-form-item>
                  <nz-form-label>{{ 'Close Parenthesis' | truncate:6 }}</nz-form-label>
                  <nz-form-control>
                    <nz-select [formControlName]="'pairCloseBraces_' + i" [nzPlaceHolder]="'Select'" nzAllowClear>
                      <nz-option *ngFor="let brace of closeBraces"
                        [nzLabel]="brace.label | truncate:15" [nzValue]="brace.code"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Logical Operator -->
              <div nz-col nzXl="5" nzLg="5" nzMd="12" nzSm="24">
                <nz-form-item>
                  <nz-form-label nzRequired>Logical Operator</nz-form-label>
                  <nz-form-control [nzErrorTip]="'Please select logical operator'">
                    <nz-select [formControlName]="'pairLogicalOperator_' + i"
                      [nzPlaceHolder]="'Select'" nzAllowClear
                      [nzDisabled]="isPairLogicalOperatorDisabled(pairConfig, i)">
                      <nz-option nzValue="==" nzLabel="=="></nz-option>
                      <nz-option nzValue="AND" nzLabel="AND"></nz-option>
                      <nz-option nzValue="OR" nzLabel="OR"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

            </div><!-- /pair row loop -->
          </div>
        </ng-container><!-- /pairControls loop -->

        <!-- Save / Cancel -->
        <div nz-row class="text-right">
          <div nz-col nzXl="24">
            <button type="button" nz-button nzType="primary" (click)="onSaveRule()"
              [disabled]="formService.ruleForm.invalid" class="mr-md">
              <i nz-icon nzType="save"></i> Save
            </button>
            <button type="button" nz-button (click)="onCancelRule()" [disabled]="isCancelDisabled()">
              <i nz-icon nzType="close"></i> Cancel
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>

  <!-- Rules table -->
  <div nz-row class="mb-lg" *ngIf="rulesList && rulesList.length > 0">
    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24">

      <div class="expression-preview-wrapper">
        <div class="expression-icon"
          [ngClass]="validationStatus === 'success' ? 'success-box' : validationStatus === 'warning' ? 'warning-box' : 'error-box'">
          <i nz-icon [nzType]="validationStatus === 'success' ? 'check-circle' : validationStatus === 'warning' ? 'warning' : 'close-circle'" nzTheme="outline" class="tooltip" nz-popover [nzPopoverContent]="validationPopover" nzPopoverTrigger="hover"></i>
        </div>

        <ng-template #validationPopover>
          <div class="validation-popover-content">
            <div class="validation-header">
              <span>{{ validationStatus === 'success' ? validationMessage : validationStatus === 'warning' ? 'Warnings' : validationMessage }}</span>
            </div>
            <div class="validation-errors-list" *ngIf="validationMessageList && validationMessageList.length > 0">
              <div class="error-item" *ngFor="let error of validationMessageList">
                <i nz-icon nzType="close-circle" nzTheme="outline" class="error-icon"></i>
                <span>{{ error }}</span>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="expresstion-detail">
          <div class="expresstion-text-title"><strong>Expression Preview</strong></div>
          <div class="expression-preview">
            <ng-container *ngFor="let token of expressionTokens">
              <span *ngIf="token.isNumber" [nz-tooltip]="getTooltipContent(token.value)"
                class="tooltip-underline"
                [nzTooltipOverlayStyle]="{'white-space': 'normal', 'max-width': getTooltipMaxWidth()}">
                Rule {{ token.value }}
              </span>
              <span *ngIf="!token.isNumber">{{ token.value }}</span>
            </ng-container>
            <div *ngIf="validationErrors && validationErrors.length > 0">
              <strong>Warnings:</strong>
              <ul class="warning-list">
                <li *ngFor="let error of validationErrors" class="warning-item">{{ error }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-md row-page">
        <div>
          <span class="fw-bold">Business Rules ({{getTotalRulesCount()}})
            <span class="color-red">*</span>
          </span>
        </div>
        <div>
          <span class="mr-sm">Rows per page:</span>
          <nz-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)" class="w80 inline-block">
            <nz-option [nzValue]="5" nzLabel="5"></nz-option>
            <nz-option [nzValue]="10" nzLabel="10"></nz-option>
            <nz-option [nzValue]="20" nzLabel="20"></nz-option>
          </nz-select>
        </div>
      </div>

      <nz-table class="declaration-table" [nzData]="getPaginatedRules()"
        [nzShowPagination]="false" [nzScroll]="{ x: '1060px' }">
        <thead>
          <tr>
            <th nzWidth="50px" nz-tooltip [nzTooltipTitle]="'Rule No.'.length > 10 ? 'Rule No.' : null">{{ 'Rule No.' | truncate:10 }}</th>
            <th nzWidth="50px" nz-tooltip [nzTooltipTitle]="'Open Parenthesis'.length > 6 ? 'Open Parenthesis' : null">{{ 'Open Parenthesis' | truncate:6 }}</th>
            <th nzWidth="120px" nz-tooltip [nzTooltipTitle]="(('ics.intelligencemgmt.attributeName' | translate).length > 20) ? ('ics.intelligencemgmt.attributeName' | translate) : null">{{ ('ics.intelligencemgmt.attributeName' | translate) | truncate:20 }}</th>
            <th nzWidth="60px" nz-tooltip [nzTooltipTitle]="(('intelligencemgmt.operator' | translate).length > 10) ? ('intelligencemgmt.operator' | translate) : null">{{ ('intelligencemgmt.operator' | translate) | truncate:10 }}</th>
            <th nzWidth="200px" nz-tooltip [nzTooltipTitle]="'Value/Field'.length > 20 ? 'Value/Field' : null">{{ 'Value/Field' | truncate:20 }}</th>
            <th nzWidth="50px" nz-tooltip [nzTooltipTitle]="'Close Parenthesis'.length > 6 ? 'Close Parenthesis' : null">{{ 'Close Parenthesis' | truncate:6 }}</th>
            <th nzWidth="100px" nz-tooltip [nzTooltipTitle]="(('ics.intelligencemgmt.logicalOperator' | translate).length > 20) ? ('ics.intelligencemgmt.logicalOperator' | translate) : null">{{ ('ics.intelligencemgmt.logicalOperator' | translate) | truncate:20 }}</th>
            <th nzWidth="80px" nz-tooltip [nzTooltipTitle]="'Actions'.length > 20 ? 'Actions' : null">{{ 'Actions' | truncate:20 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rule of getPaginatedRules(); let i = index">
            <td>Rule {{ rule.sequence || (i + 1) }}</td>
            <td>{{ getBraceLabel(rule.openBraces, 'open') }}</td>
            <td [nzTooltipTitle]="getFullAttributeName(rule.attributeName)" nz-tooltip>{{ formatAttributeName(rule.attributeName) }}</td>
            <td>{{ rule.operator }}</td>
            <td [style.cursor]="getRefTypeCode(rule) ? 'pointer' : 'default'" (click)="openRuleValueDialog(rule)" [nzTooltipTitle]="getRefTypeCode(rule) ? 'Click to view values' : ''" nz-tooltip>
              {{ formatRuleValue(rule) }}
            </td>
            <td>{{ getBraceLabel(rule.closeBraces, 'close') }}</td>
            <td>{{ rule.logicalOperator }}</td>
            <td>
              <ng-container *ngIf="rule?.metaData.action">
                <button type="button" nz-button nzType="link"
                  (click)="onEditRule((pageIndex - 1) * pageSize + i, i)"
                  nz-tooltip nzTooltipTitle="Edit">
                  <i nz-icon nzType="edit"></i>
                </button>
                <button type="button" nz-button nzType="link" nzDanger
                  (click)="onRemoveRule((pageIndex - 1) * pageSize + i)"
                  nz-tooltip nzTooltipTitle="Delete"
                  [disabled]="_rulesList[(pageIndex - 1) * pageSize + i]?.isEdit || false">
                  <i nz-icon nzType="delete"></i>
                </button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <div class="mt-md pagination-container">
        <div>
          <nz-pagination [(nzPageIndex)]="pageIndex" [nzTotal]="getTotalRulesCount()"
            [nzPageSize]="pageSize" (nzPageIndexChange)="onPageChange($event)"></nz-pagination>
        </div>
        <div>
          <span class="mr-sm">Go to:</span>
          <input nz-input [(ngModel)]="gotoPageNumber" placeholder="Page" class="inline-block w80 mr-sm" />
          <button nz-button nzType="primary" (click)="goToPage()">Go</button>
        </div>
      </div>

    </div>
  </div>
</div>